/* MOD-033 — Mockup/Framed product image swap toggle.

   Wires the pill buttons in the sticky filter bar to a class on <html> that
   flips which of the two product card images (mockup vs framed) is shown at
   rest vs on hover. Persists the choice in localStorage so returning visits
   open in the chosen view. The class is also set pre-paint by the inline
   script in layout/theme.liquid for flicker-free return visits.

   Event-delegated on document so this works regardless of where the toggle
   buttons are mounted (collection page now; potentially other surfaces in the
   future). */
(function () {
  'use strict';

  var STORAGE_KEY = 'moryarty-swap-images';
  var CLASS_NAME = 'swap-product-images';

  function syncButtonStates(isSwapped) {
    document.querySelectorAll('[data-view-primary]').forEach(function (b) {
      b.setAttribute('aria-pressed', isSwapped ? 'false' : 'true');
    });
    document.querySelectorAll('[data-view-secondary]').forEach(function (b) {
      b.setAttribute('aria-pressed', isSwapped ? 'true' : 'false');
    });
  }

  // Initial sync — the head script may have set the class already; match button states.
  syncButtonStates(document.documentElement.classList.contains(CLASS_NAME));

  // Event delegation — works no matter where (or if multiple instances of)
  // the toggle buttons are mounted.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-view-primary], [data-view-secondary]');
    if (!btn) return;
    e.preventDefault();
    var next = btn.hasAttribute('data-view-secondary');
    document.documentElement.classList.toggle(CLASS_NAME, next);
    syncButtonStates(next);
    try { localStorage.setItem(STORAGE_KEY, next ? '1' : '0'); } catch (err) {}
  });
})();
